import React, { useEffect } from 'react'
import { AppBar, Toolbar, IconButton, Badge, FormControl, OutlinedInput, InputAdornment, Button } from '@material-ui/core';
import { ShoppingCart } from '@material-ui/icons';
import { Link, useHistory } from 'react-router-dom';
import { BsSearch } from 'react-icons/bs'
import useStyles from './style';
import Logo from '../Logo';
import { useState } from 'react';

const Navbar = ({ totalProducts, fetchProduct }) => {
    const classes = useStyles();
    const history = useHistory();
    // const location = useLocation();
    // const params = useParams()
    const [state, setState] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        if (state && !(/^\s*$/.test(state))) {
            fetchProduct(state)
            history.push(`/search/${state}`)
        } 
    }

    // useEffect(() => {
    //     console.log({location, params});
    // }, [])

    return (
        <>
            <AppBar position='fixed' className={classes.appBar} >
                <Toolbar className={classes.Toolbar}>
                    <Logo hide={true} />

                    <form onSubmit={handleSubmit} className={classes.form}>
                        <FormControl variant="outlined" className={classes.formControl}>
                            <OutlinedInput
                                id="serch"
                                type="text"
                                value={state}
                                className={classes.searchInput}
                                placeholder=' Search for...'
                                onChange={(e) => { setState(e.target.value) }}
                                startAdornment={
                                    <InputAdornment position="start">
                                        <IconButton disabled>
                                            <BsSearch />
                                        </IconButton>
                                    </InputAdornment>
                                }
                                endAdornment={
                                    <InputAdornment position="end">
                                        <Button className={classes.searchButton} color='default' type='submit'>
                                            Search
                                        </Button>
                                    </InputAdornment>
                                }
                            />
                        </FormControl>
                    </form>

                    <div className={classes.shoppingCart}>
                        <IconButton component={Link} to="/cart" aria-label="Cart Items" color="inherit">
                            <Badge badgeContent={totalProducts} color="secondary">
                                <ShoppingCart />
                            </Badge>
                        </IconButton>
                    </div>
                </Toolbar>
            </AppBar>
        </>
    )
}

export default Navbar
